/** U14 F5: textos da aba Broadcast (disparo de template do WhatsApp). Entram no namespace `automacoes` como `broadcast`. */
const pt = {
  novo: 'Novo disparo',
  nome: 'Nome do disparo',
  criado: 'Disparo criado',
  vazio: 'Nenhum disparo ainda. Crie o primeiro: escolha o template aprovado, o público e quando enviar.',
  vazioLeitura: 'Nenhum disparo ainda.',
  colunas: { nome: 'Disparo', estado: 'Situação', template: 'Template', quando: 'Quando', enviados: 'Enviados', entregues: 'Entregues', lidos: 'Lidos', falhas: 'Falhas', cliques: 'Cliques' },
  filtros: { todos: 'Todos', rascunho: 'Rascunhos', agendado: 'Agendados', enviando: 'Enviando', pausado: 'Pausados', concluido: 'Concluídos', cancelado: 'Cancelados' },
  estados: { rascunho: 'Rascunho', agendado: 'Agendado', enviando: 'Enviando', pausado: 'Pausado', concluido: 'Concluído', cancelado: 'Cancelado' },
  tipos: { marketing: 'Marketing', avisos: 'Avisos' },
  voltar: 'Voltar aos disparos',
  abas: { configuracao: 'Configuração', relatorio: 'Relatório' },
  semConversas: 'O módulo Conversas não está instalado: o Broadcast não tem template nem envio até ele estar.',
  grupo: 'O WhatsApp é do grupo: o disparo vale para os contatos de todas as empresas, e só quem vê todas as empresas cria e dispara.',
  acoes: {
    salvar: 'Salvar',
    salvo: 'Disparo salvo',
    disparar: 'Enviar agora',
    agendar: 'Agendar',
    pausar: 'Pausar',
    retomar: 'Retomar',
    cancelar: 'Cancelar disparo',
    desagendar: 'Desfazer agendamento',
    conferir: 'Conferir público',
    enviado: 'Disparo começou: {{n}} destinatários',
    agendado: 'Disparo agendado para {{quando}}: {{n}} destinatários',
    feito: 'Pronto',
    salveAntes: 'Salve as mudanças antes de enviar',
  },
  confirmar: {
    dispararTitulo: 'Enviar o template para o público?',
    dispararTexto: 'Cada destinatário recebe um template, no ritmo escolhido. O que já saiu não volta.',
    cancelarTitulo: 'Cancelar o disparo?',
    cancelarTexto: 'Ninguém mais recebe; o que já saiu continua no relatório.',
  },
  secoes: { template: 'Template', variaveis: 'Variáveis', cabecalho: 'Cabeçalho', botoes: 'Botões', publico: 'Público', envio: 'Envio', pendencias: 'Antes de enviar', previa: 'Prévia do público' },
  template: {
    escolher: 'Template aprovado',
    nenhum: 'Escolha o template',
    semAprovados: 'Nenhum template aprovado. Sincronize em Comercial > Conversas > Templates.',
    categoria: 'Categoria: {{categoria}}',
    categorias: { marketing: 'Marketing', utilidade: 'Utilidade', autenticacao: 'Autenticação' },
    exigeMarketing: 'Marketing: só recebe quem autorizou ou conversou com a empresa, e o template precisa de um botão "Parar de receber".',
    exigeAvisos: 'Utilidade (avisos): recebe também o cliente com contrato ativo.',
    corpo: 'Corpo',
    mudou: 'O template mudou ou não está mais aprovado na Meta: escolha de novo.',
  },
  variavel: {
    rotulo: 'Variável {{n}}',
    origem: 'De onde vem',
    origens: { campo: 'Campo do cadastro', coluna: 'Coluna da planilha', fixo: 'Texto fixo' },
    campos: { nome: 'Nome', primeiro_nome: 'Primeiro nome', telefone: 'Telefone', email: 'E-mail', codigo: 'Código do cadastro' },
    valor: 'Texto',
    coluna: 'Coluna',
    semVariaveis: 'Este template não tem variáveis.',
  },
  cabecalho: { link: 'Link do arquivo (https)', linkAjuda: 'Imagem, vídeo ou documento do cabeçalho, num endereço https público.', variavel: 'Variável do cabeçalho' },
  botao: {
    rotulo: 'Botão {{n}}: {{texto}}',
    acao: 'Ao tocar',
    acoes: { nada: 'Só registrar o clique', parar: 'Parar de receber (sai da lista)', fluxo: 'Começar uma automação' },
    fluxo: 'Automação',
    semFluxos: 'Nenhuma automação do grupo com o gatilho "Clique em botão de broadcast". Crie uma em Automações > Automações.',
    naoPublicada: '{{nome}} (não publicada)',
    pausada: '{{nome}} (pausada)',
    link: 'Final do link',
    codigo: 'Código a copiar',
    semBotoes: 'Este template não tem botões.',
    outro: 'Botão de telefone ou link fixo: não pede nada.',
  },
  publico: {
    fonte: 'Quem recebe',
    fontes: { etiquetas: 'Etiquetas', cadastros: 'Cadastros', segmento: 'Segmento', planilha: 'Planilha' },
    etiquetas: 'Etiquetas da conversa do WhatsApp',
    semEtiquetas: 'Nenhuma etiqueta em uso nas conversas.',
    cadastro: 'Incluir cadastro',
    remover: 'Tirar {{nome}}',
    tags: 'Tags',
    setores: 'Setores',
    planilha: 'Arquivo CSV',
    planilhaAjuda: 'Primeira linha com os nomes das colunas; uma coluna de telefone (telefone, celular ou whatsapp) e, se quiser, nome e outras colunas para as variáveis. Até 10 mil linhas.',
    planilhaLida: '{{n}} linhas lidas; colunas: {{colunas}}',
    planilhaSalva_one: '{{count}} linha na planilha salva',
    planilhaSalva_other: '{{count}} linhas na planilha salva',
    apagarPlanilha: 'Tirar a planilha',
    declarar: 'Declaro que os contatos desta planilha autorizaram receber mensagens da empresa pelo WhatsApp.',
    declarado: 'Declarado por {{nome}} em {{quando}}',
    declaracaoAjuda: 'Sem a declaração, só recebe quem já autorizou (conversa, formulário ou registro). Quem saiu da lista não volta pela planilha.',
    erros: {
      vazia: 'A planilha está vazia',
      sem_telefone: 'A planilha não tem coluna de telefone (telefone, celular ou whatsapp)',
      linhas_demais: 'A planilha passa de 10 mil linhas',
      colunas_demais: 'A planilha passa de 20 colunas',
    },
  },
  envio: {
    ritmo: 'Ritmo (mensagens por segundo)',
    ritmoAjuda: 'O WhatsApp aceita até 80 por segundo por número. Mais devagar é mais seguro para a qualidade do número.',
    limite: 'Limite do número em 24 horas',
    limiteAjuda: 'O limite de destinatários únicos que a Meta deu ao seu número. O disparo espera a janela liberar.',
    limites: { '250': '250', '2000': '2 mil', '10000': '10 mil', '100000': '100 mil', ilimitado: 'Ilimitado' },
    agendarPara: 'Agendar para',
    agendadoPara: 'Agendado para {{quando}}',
  },
  problemas: {
    template_categoria: 'Escolha um template aprovado de marketing ou de utilidade',
    variaveis: 'Ligue cada variável do template a um campo, uma coluna ou um texto',
    cabecalho: 'Preencha o cabeçalho do template',
    botao_parar: 'Template de marketing: ligue um botão a "Parar de receber"',
    botao_fluxo: 'Escolha a automação do botão',
    botoes: 'Confira os botões do template (final do link e código)',
    publico_vazio: 'Escolha o público',
    declaracao: 'Faça a declaração da planilha',
  },
  previa: {
    encontrados: 'No filtro',
    recebem: 'Recebem',
    semConsentimento: 'Sem consentimento',
    saiu: 'Saíram da lista',
    invalidos: 'Telefone inválido',
    repetidos: 'Repetidos',
    variavelVazia: 'Variável vazia',
    acimaDoTeto: 'O público passa de 10 mil contatos: divida em mais de um disparo.',
    amostra: 'Amostra',
    recebe: 'Recebe',
    naoRecebe: 'Não recebe',
  },
  relatorio: {
    total: 'Destinatários',
    enviados: 'Enviados',
    entregues: 'Entregues',
    lidos: 'Lidos',
    falhas: 'Falhas',
    ignorados: 'Fora do envio',
    cliques: 'Cliques',
    saidas: 'Saíram da lista',
    porBotao: 'Cliques por botão',
    porErro: 'Falhas por motivo',
    porMotivo: 'Fora do envio, por motivo',
    destinatarios: 'Destinatários',
    semRelatorio: 'O relatório aparece quando o disparo começa.',
    detalhe: 'De {{total}}',
    taxa: '{{pct}} dos enviados',
    nada: 'Nada ainda',
    semDestinatarios: 'Nenhum destinatário neste filtro.',
  },
  destinatario: {
    telefone: 'Telefone',
    nome: 'Nome',
    estado: 'Situação',
    detalhe: 'Detalhe',
    botao: 'Botão',
    saiu: 'Saiu',
    filtroEstado: 'Situação',
    todos: 'Todos',
    clicaram: 'Clicaram',
    tentativas_one: '{{count}} tentativa',
    tentativas_other: '{{count}} tentativas',
    abrirConversa: 'Abrir a conversa',
  },
  estadosDestinatario: { pendente: 'Na fila', enviando: 'Enviando', enviado: 'Enviado', entregue: 'Entregue', lido: 'Lido', falhou: 'Falhou', ignorado: 'Fora do envio' },
  motivos: {
    sem_consentimento: 'Sem consentimento',
    saiu: 'Saiu da lista',
    telefone_invalido: 'Telefone inválido',
    repetido: 'Repetido',
    variavel_vazia: 'Variável vazia',
    cancelado: 'Disparo cancelado',
    falha_provedor: 'Falha informada pelo provedor',
    limite_24h: 'Esperando o limite do número em 24 horas',
    template_nao_aprovado: 'O template não está aprovado na Meta',
    template_inexistente: 'O template não existe mais',
    template_categoria_mudou: 'A Meta mudou a categoria do template',
    whatsapp_desconectado: 'O WhatsApp (API oficial) está desconectado',
    conversas_indisponivel: 'O Conversas não está disponível',
  },
  erros: {
    '131047': '131047 · Janela de 24 horas fechada',
    '131026': '131026 · Número sem WhatsApp ou que não aceita a mensagem',
    '131048': '131048 · Restrição por spam (qualidade do número)',
    '131049': '131049 · Limite de marketing por usuário (a Meta pede esperar 24 h)',
    '131056': '131056 · Muitas mensagens ao mesmo número',
    '130429': '130429 · Vazão do número',
    '132000': '132000 · Variáveis do template',
    '132001': '132001 · Template inexistente ou não aprovado',
    outro: '{{codigo}} · Erro da Meta',
    semCodigo: 'Recusado pelo MalgoOS (telefone ou variáveis)',
  },
  consentimentos: {
    abrir: 'Consentimentos',
    titulo: 'Consentimentos do WhatsApp',
    texto: 'Quem pode receber mensagens: o registro de cada autorização e de cada saída, com a origem, a data e quem registrou. Sem registro vale a regra padrão: quem escreveu para a empresa recebe; o cliente com contrato ativo recebe avisos.',
    colunas: { contato: 'Contato', tipo: 'Tipo', situacao: 'Situação', origem: 'Origem', quem: 'Quem registrou', quando: 'Quando' },
    situacoes: { autorizou: 'Autorizou', saiu: 'Saiu' },
    origens: { contrato: 'Contrato ativo', conversa: 'Escreveu para a empresa', formulario: 'Formulário do site', importacao: 'Planilha declarada', manual: 'Registro manual', botao_parar: 'Botão "Parar de receber"', palavra: 'Pediu na conversa' },
    registrar: 'Registrar',
    telefone: 'Telefone',
    tipos: 'Vale para',
    tiposOpcoes: { ambos: 'Marketing e avisos', marketing: 'Só marketing', avisos: 'Só avisos' },
    situacao: 'Situação',
    observacao: 'Observação (como o contato pediu ou autorizou)',
    registrado: 'Consentimento registrado',
    vazio: 'Nenhum registro ainda.',
    sistema: 'Automático',
  },
};

const en: typeof pt = {
  novo: 'New broadcast',
  nome: 'Broadcast name',
  criado: 'Broadcast created',
  vazio: 'No broadcasts yet. Create the first one: pick the approved template, the audience and when to send.',
  vazioLeitura: 'No broadcasts yet.',
  colunas: { nome: 'Broadcast', estado: 'Status', template: 'Template', quando: 'When', enviados: 'Sent', entregues: 'Delivered', lidos: 'Read', falhas: 'Failed', cliques: 'Clicks' },
  filtros: { todos: 'All', rascunho: 'Drafts', agendado: 'Scheduled', enviando: 'Sending', pausado: 'Paused', concluido: 'Finished', cancelado: 'Canceled' },
  estados: { rascunho: 'Draft', agendado: 'Scheduled', enviando: 'Sending', pausado: 'Paused', concluido: 'Finished', cancelado: 'Canceled' },
  tipos: { marketing: 'Marketing', avisos: 'Notices' },
  voltar: 'Back to broadcasts',
  abas: { configuracao: 'Setup', relatorio: 'Report' },
  semConversas: 'The Conversations module is not installed: Broadcast has no templates or sending until it is.',
  grupo: 'WhatsApp belongs to the group: the broadcast covers the contacts of every company, and only people who see every company create and send it.',
  acoes: {
    salvar: 'Save',
    salvo: 'Broadcast saved',
    disparar: 'Send now',
    agendar: 'Schedule',
    pausar: 'Pause',
    retomar: 'Resume',
    cancelar: 'Cancel broadcast',
    desagendar: 'Unschedule',
    conferir: 'Check audience',
    enviado: 'Broadcast started: {{n}} recipients',
    agendado: 'Broadcast scheduled for {{quando}}: {{n}} recipients',
    feito: 'Done',
    salveAntes: 'Save your changes before sending',
  },
  confirmar: {
    dispararTitulo: 'Send the template to the audience?',
    dispararTexto: 'Each recipient gets one template, at the chosen rate. What has been sent cannot be undone.',
    cancelarTitulo: 'Cancel the broadcast?',
    cancelarTexto: 'Nobody else receives it; what was sent stays in the report.',
  },
  secoes: { template: 'Template', variaveis: 'Variables', cabecalho: 'Header', botoes: 'Buttons', publico: 'Audience', envio: 'Sending', pendencias: 'Before sending', previa: 'Audience preview' },
  template: {
    escolher: 'Approved template',
    nenhum: 'Pick the template',
    semAprovados: 'No approved templates. Sync them in Sales > Conversations > Templates.',
    categoria: 'Category: {{categoria}}',
    categorias: { marketing: 'Marketing', utilidade: 'Utility', autenticacao: 'Authentication' },
    exigeMarketing: 'Marketing: only people who opted in or talked to the company receive it, and the template needs a "Stop receiving" button.',
    exigeAvisos: 'Utility (notices): clients with an active contract also receive it.',
    corpo: 'Body',
    mudou: 'The template changed or is no longer approved by Meta: pick it again.',
  },
  variavel: {
    rotulo: 'Variable {{n}}',
    origem: 'Comes from',
    origens: { campo: 'Contact field', coluna: 'Spreadsheet column', fixo: 'Fixed text' },
    campos: { nome: 'Name', primeiro_nome: 'First name', telefone: 'Phone', email: 'Email', codigo: 'Contact code' },
    valor: 'Text',
    coluna: 'Column',
    semVariaveis: 'This template has no variables.',
  },
  cabecalho: { link: 'File link (https)', linkAjuda: 'Header image, video or document at a public https address.', variavel: 'Header variable' },
  botao: {
    rotulo: 'Button {{n}}: {{texto}}',
    acao: 'On tap',
    acoes: { nada: 'Only record the click', parar: 'Stop receiving (leaves the list)', fluxo: 'Start an automation' },
    fluxo: 'Automation',
    semFluxos: 'No group automation with the "Broadcast button click" trigger. Create one in Automations > Automations.',
    naoPublicada: '{{nome}} (not published)',
    pausada: '{{nome}} (paused)',
    link: 'Link ending',
    codigo: 'Code to copy',
    semBotoes: 'This template has no buttons.',
    outro: 'Phone or fixed link button: nothing to fill.',
  },
  publico: {
    fonte: 'Who receives',
    fontes: { etiquetas: 'Labels', cadastros: 'Contacts', segmento: 'Segment', planilha: 'Spreadsheet' },
    etiquetas: 'WhatsApp conversation labels',
    semEtiquetas: 'No labels in use in conversations.',
    cadastro: 'Add contact',
    remover: 'Remove {{nome}}',
    tags: 'Tags',
    setores: 'Sectors',
    planilha: 'CSV file',
    planilhaAjuda: 'First row with the column names; one phone column (phone, mobile or whatsapp) and, optionally, name and other columns for the variables. Up to 10 thousand rows.',
    planilhaLida: '{{n}} rows read; columns: {{colunas}}',
    planilhaSalva_one: '{{count}} row in the saved spreadsheet',
    planilhaSalva_other: '{{count}} rows in the saved spreadsheet',
    apagarPlanilha: 'Remove the spreadsheet',
    declarar: 'I declare that the contacts in this spreadsheet agreed to receive messages from the company on WhatsApp.',
    declarado: 'Declared by {{nome}} on {{quando}}',
    declaracaoAjuda: 'Without the declaration, only people who already opted in (conversation, form or record) receive it. People who left the list do not come back through the spreadsheet.',
    erros: {
      vazia: 'The spreadsheet is empty',
      sem_telefone: 'The spreadsheet has no phone column (phone, mobile or whatsapp)',
      linhas_demais: 'The spreadsheet has more than 10 thousand rows',
      colunas_demais: 'The spreadsheet has more than 20 columns',
    },
  },
  envio: {
    ritmo: 'Rate (messages per second)',
    ritmoAjuda: 'WhatsApp accepts up to 80 per second per number. Slower is safer for the number quality.',
    limite: 'Number limit in 24 hours',
    limiteAjuda: 'The unique recipient limit Meta gave your number. The broadcast waits for the window to free up.',
    limites: { '250': '250', '2000': '2 thousand', '10000': '10 thousand', '100000': '100 thousand', ilimitado: 'Unlimited' },
    agendarPara: 'Schedule for',
    agendadoPara: 'Scheduled for {{quando}}',
  },
  problemas: {
    template_categoria: 'Pick an approved marketing or utility template',
    variaveis: 'Link each template variable to a field, a column or a text',
    cabecalho: 'Fill in the template header',
    botao_parar: 'Marketing template: link a button to "Stop receiving"',
    botao_fluxo: 'Pick the button automation',
    botoes: 'Check the template buttons (link ending and code)',
    publico_vazio: 'Pick the audience',
    declaracao: 'Make the spreadsheet declaration',
  },
  previa: {
    encontrados: 'In the filter',
    recebem: 'Receive',
    semConsentimento: 'No consent',
    saiu: 'Left the list',
    invalidos: 'Invalid phone',
    repetidos: 'Duplicates',
    variavelVazia: 'Empty variable',
    acimaDoTeto: 'The audience has more than 10 thousand contacts: split it into more than one broadcast.',
    amostra: 'Sample',
    recebe: 'Receives',
    naoRecebe: 'Does not receive',
  },
  relatorio: {
    total: 'Recipients',
    enviados: 'Sent',
    entregues: 'Delivered',
    lidos: 'Read',
    falhas: 'Failed',
    ignorados: 'Not sent',
    cliques: 'Clicks',
    saidas: 'Left the list',
    porBotao: 'Clicks per button',
    porErro: 'Failures by reason',
    porMotivo: 'Not sent, by reason',
    destinatarios: 'Recipients',
    semRelatorio: 'The report appears when the broadcast starts.',
    detalhe: 'Out of {{total}}',
    taxa: '{{pct}} of sent',
    nada: 'Nothing yet',
    semDestinatarios: 'No recipients in this filter.',
  },
  destinatario: {
    telefone: 'Phone',
    nome: 'Name',
    estado: 'Status',
    detalhe: 'Detail',
    botao: 'Button',
    saiu: 'Left',
    filtroEstado: 'Status',
    todos: 'All',
    clicaram: 'Clicked',
    tentativas_one: '{{count}} attempt',
    tentativas_other: '{{count}} attempts',
    abrirConversa: 'Open the conversation',
  },
  estadosDestinatario: { pendente: 'Queued', enviando: 'Sending', enviado: 'Sent', entregue: 'Delivered', lido: 'Read', falhou: 'Failed', ignorado: 'Not sent' },
  motivos: {
    sem_consentimento: 'No consent',
    saiu: 'Left the list',
    telefone_invalido: 'Invalid phone',
    repetido: 'Duplicate',
    variavel_vazia: 'Empty variable',
    cancelado: 'Broadcast canceled',
    falha_provedor: 'Failure reported by the provider',
    limite_24h: 'Waiting for the number 24-hour limit',
    template_nao_aprovado: 'The template is not approved by Meta',
    template_inexistente: 'The template no longer exists',
    template_categoria_mudou: 'Meta changed the template category',
    whatsapp_desconectado: 'WhatsApp (official API) is disconnected',
    conversas_indisponivel: 'Conversations is not available',
  },
  erros: {
    '131047': '131047 · 24-hour window closed',
    '131026': '131026 · Number without WhatsApp or that does not accept the message',
    '131048': '131048 · Spam restriction (number quality)',
    '131049': '131049 · Per-user marketing limit (Meta asks to wait 24 h)',
    '131056': '131056 · Too many messages to the same number',
    '130429': '130429 · Number throughput',
    '132000': '132000 · Template variables',
    '132001': '132001 · Template missing or not approved',
    outro: '{{codigo}} · Meta error',
    semCodigo: 'Refused by MalgoOS (phone or variables)',
  },
  consentimentos: {
    abrir: 'Consents',
    titulo: 'WhatsApp consents',
    texto: 'Who may receive messages: the record of each opt-in and each opt-out, with the source, the date and who recorded it. Without a record the default rule applies: people who wrote to the company receive; clients with an active contract receive notices.',
    colunas: { contato: 'Contact', tipo: 'Type', situacao: 'Status', origem: 'Source', quem: 'Recorded by', quando: 'When' },
    situacoes: { autorizou: 'Opted in', saiu: 'Opted out' },
    origens: { contrato: 'Active contract', conversa: 'Wrote to the company', formulario: 'Website form', importacao: 'Declared spreadsheet', manual: 'Manual record', botao_parar: '"Stop receiving" button', palavra: 'Asked in the conversation' },
    registrar: 'Record',
    telefone: 'Phone',
    tipos: 'Applies to',
    tiposOpcoes: { ambos: 'Marketing and notices', marketing: 'Marketing only', avisos: 'Notices only' },
    situacao: 'Status',
    observacao: 'Note (how the contact asked or agreed)',
    registrado: 'Consent recorded',
    vazio: 'No records yet.',
    sistema: 'Automatic',
  },
};

const es: typeof pt = {
  novo: 'Nueva difusión',
  nome: 'Nombre de la difusión',
  criado: 'Difusión creada',
  vazio: 'Aún no hay difusiones. Crea la primera: elige la plantilla aprobada, el público y cuándo enviar.',
  vazioLeitura: 'Aún no hay difusiones.',
  colunas: { nome: 'Difusión', estado: 'Estado', template: 'Plantilla', quando: 'Cuándo', enviados: 'Enviados', entregues: 'Entregados', lidos: 'Leídos', falhas: 'Fallos', cliques: 'Clics' },
  filtros: { todos: 'Todas', rascunho: 'Borradores', agendado: 'Programadas', enviando: 'Enviando', pausado: 'Pausadas', concluido: 'Concluidas', cancelado: 'Canceladas' },
  estados: { rascunho: 'Borrador', agendado: 'Programada', enviando: 'Enviando', pausado: 'Pausada', concluido: 'Concluida', cancelado: 'Cancelada' },
  tipos: { marketing: 'Marketing', avisos: 'Avisos' },
  voltar: 'Volver a las difusiones',
  abas: { configuracao: 'Configuración', relatorio: 'Informe' },
  semConversas: 'El módulo Conversaciones no está instalado: el Broadcast no tiene plantillas ni envío hasta que lo esté.',
  grupo: 'El WhatsApp es del grupo: la difusión vale para los contactos de todas las empresas, y solo quien ve todas las empresas la crea y la envía.',
  acoes: {
    salvar: 'Guardar',
    salvo: 'Difusión guardada',
    disparar: 'Enviar ahora',
    agendar: 'Programar',
    pausar: 'Pausar',
    retomar: 'Reanudar',
    cancelar: 'Cancelar difusión',
    desagendar: 'Deshacer la programación',
    conferir: 'Revisar público',
    enviado: 'La difusión empezó: {{n}} destinatarios',
    agendado: 'Difusión programada para {{quando}}: {{n}} destinatarios',
    feito: 'Listo',
    salveAntes: 'Guarda los cambios antes de enviar',
  },
  confirmar: {
    dispararTitulo: '¿Enviar la plantilla al público?',
    dispararTexto: 'Cada destinatario recibe una plantilla, al ritmo elegido. Lo que ya salió no vuelve.',
    cancelarTitulo: '¿Cancelar la difusión?',
    cancelarTexto: 'Nadie más la recibe; lo que ya salió sigue en el informe.',
  },
  secoes: { template: 'Plantilla', variaveis: 'Variables', cabecalho: 'Encabezado', botoes: 'Botones', publico: 'Público', envio: 'Envío', pendencias: 'Antes de enviar', previa: 'Vista previa del público' },
  template: {
    escolher: 'Plantilla aprobada',
    nenhum: 'Elige la plantilla',
    semAprovados: 'Ninguna plantilla aprobada. Sincronízalas en Comercial > Conversaciones > Plantillas.',
    categoria: 'Categoría: {{categoria}}',
    categorias: { marketing: 'Marketing', utilidade: 'Utilidad', autenticacao: 'Autenticación' },
    exigeMarketing: 'Marketing: solo recibe quien autorizó o conversó con la empresa, y la plantilla necesita un botón "Dejar de recibir".',
    exigeAvisos: 'Utilidad (avisos): también recibe el cliente con contrato activo.',
    corpo: 'Cuerpo',
    mudou: 'La plantilla cambió o ya no está aprobada en Meta: elígela de nuevo.',
  },
  variavel: {
    rotulo: 'Variable {{n}}',
    origem: 'De dónde viene',
    origens: { campo: 'Campo del registro', coluna: 'Columna de la planilla', fixo: 'Texto fijo' },
    campos: { nome: 'Nombre', primeiro_nome: 'Primer nombre', telefone: 'Teléfono', email: 'Correo', codigo: 'Código del registro' },
    valor: 'Texto',
    coluna: 'Columna',
    semVariaveis: 'Esta plantilla no tiene variables.',
  },
  cabecalho: { link: 'Enlace del archivo (https)', linkAjuda: 'Imagen, video o documento del encabezado, en una dirección https pública.', variavel: 'Variable del encabezado' },
  botao: {
    rotulo: 'Botón {{n}}: {{texto}}',
    acao: 'Al tocar',
    acoes: { nada: 'Solo registrar el clic', parar: 'Dejar de recibir (sale de la lista)', fluxo: 'Empezar una automatización' },
    fluxo: 'Automatización',
    semFluxos: 'Ninguna automatización del grupo con el disparador "Clic en botón de difusión". Crea una en Automatizaciones > Automatizaciones.',
    naoPublicada: '{{nome}} (sin publicar)',
    pausada: '{{nome}} (pausada)',
    link: 'Final del enlace',
    codigo: 'Código para copiar',
    semBotoes: 'Esta plantilla no tiene botones.',
    outro: 'Botón de teléfono o enlace fijo: no pide nada.',
  },
  publico: {
    fonte: 'Quién recibe',
    fontes: { etiquetas: 'Etiquetas', cadastros: 'Registros', segmento: 'Segmento', planilha: 'Planilla' },
    etiquetas: 'Etiquetas de la conversación de WhatsApp',
    semEtiquetas: 'Ninguna etiqueta en uso en las conversaciones.',
    cadastro: 'Incluir registro',
    remover: 'Quitar {{nome}}',
    tags: 'Tags',
    setores: 'Sectores',
    planilha: 'Archivo CSV',
    planilhaAjuda: 'Primera fila con los nombres de las columnas; una columna de teléfono (teléfono, celular o whatsapp) y, si quieres, nombre y otras columnas para las variables. Hasta 10 mil filas.',
    planilhaLida: '{{n}} filas leídas; columnas: {{colunas}}',
    planilhaSalva_one: '{{count}} fila en la planilla guardada',
    planilhaSalva_other: '{{count}} filas en la planilla guardada',
    apagarPlanilha: 'Quitar la planilla',
    declarar: 'Declaro que los contactos de esta planilla autorizaron recibir mensajes de la empresa por WhatsApp.',
    declarado: 'Declarado por {{nome}} el {{quando}}',
    declaracaoAjuda: 'Sin la declaración, solo recibe quien ya autorizó (conversación, formulario o registro). Quien salió de la lista no vuelve por la planilla.',
    erros: {
      vazia: 'La planilla está vacía',
      sem_telefone: 'La planilla no tiene columna de teléfono (teléfono, celular o whatsapp)',
      linhas_demais: 'La planilla pasa de 10 mil filas',
      colunas_demais: 'La planilla pasa de 20 columnas',
    },
  },
  envio: {
    ritmo: 'Ritmo (mensajes por segundo)',
    ritmoAjuda: 'WhatsApp acepta hasta 80 por segundo por número. Más despacio es más seguro para la calidad del número.',
    limite: 'Límite del número en 24 horas',
    limiteAjuda: 'El límite de destinatarios únicos que Meta dio a tu número. La difusión espera que la ventana se libere.',
    limites: { '250': '250', '2000': '2 mil', '10000': '10 mil', '100000': '100 mil', ilimitado: 'Ilimitado' },
    agendarPara: 'Programar para',
    agendadoPara: 'Programada para {{quando}}',
  },
  problemas: {
    template_categoria: 'Elige una plantilla aprobada de marketing o de utilidad',
    variaveis: 'Vincula cada variable de la plantilla a un campo, una columna o un texto',
    cabecalho: 'Completa el encabezado de la plantilla',
    botao_parar: 'Plantilla de marketing: vincula un botón a "Dejar de recibir"',
    botao_fluxo: 'Elige la automatización del botón',
    botoes: 'Revisa los botones de la plantilla (final del enlace y código)',
    publico_vazio: 'Elige el público',
    declaracao: 'Haz la declaración de la planilla',
  },
  previa: {
    encontrados: 'En el filtro',
    recebem: 'Reciben',
    semConsentimento: 'Sin consentimiento',
    saiu: 'Salieron de la lista',
    invalidos: 'Teléfono inválido',
    repetidos: 'Repetidos',
    variavelVazia: 'Variable vacía',
    acimaDoTeto: 'El público pasa de 10 mil contactos: divídelo en más de una difusión.',
    amostra: 'Muestra',
    recebe: 'Recibe',
    naoRecebe: 'No recibe',
  },
  relatorio: {
    total: 'Destinatarios',
    enviados: 'Enviados',
    entregues: 'Entregados',
    lidos: 'Leídos',
    falhas: 'Fallos',
    ignorados: 'Fuera del envío',
    cliques: 'Clics',
    saidas: 'Salieron de la lista',
    porBotao: 'Clics por botón',
    porErro: 'Fallos por motivo',
    porMotivo: 'Fuera del envío, por motivo',
    destinatarios: 'Destinatarios',
    semRelatorio: 'El informe aparece cuando la difusión empieza.',
    detalhe: 'De {{total}}',
    taxa: '{{pct}} de los enviados',
    nada: 'Nada todavía',
    semDestinatarios: 'Ningún destinatario en este filtro.',
  },
  destinatario: {
    telefone: 'Teléfono',
    nome: 'Nombre',
    estado: 'Estado',
    detalhe: 'Detalle',
    botao: 'Botón',
    saiu: 'Salió',
    filtroEstado: 'Estado',
    todos: 'Todos',
    clicaram: 'Hicieron clic',
    tentativas_one: '{{count}} intento',
    tentativas_other: '{{count}} intentos',
    abrirConversa: 'Abrir la conversación',
  },
  estadosDestinatario: { pendente: 'En cola', enviando: 'Enviando', enviado: 'Enviado', entregue: 'Entregado', lido: 'Leído', falhou: 'Falló', ignorado: 'Fuera del envío' },
  motivos: {
    sem_consentimento: 'Sin consentimiento',
    saiu: 'Salió de la lista',
    telefone_invalido: 'Teléfono inválido',
    repetido: 'Repetido',
    variavel_vazia: 'Variable vacía',
    cancelado: 'Difusión cancelada',
    falha_provedor: 'Fallo informado por el proveedor',
    limite_24h: 'Esperando el límite del número en 24 horas',
    template_nao_aprovado: 'La plantilla no está aprobada en Meta',
    template_inexistente: 'La plantilla ya no existe',
    template_categoria_mudou: 'Meta cambió la categoría de la plantilla',
    whatsapp_desconectado: 'El WhatsApp (API oficial) está desconectado',
    conversas_indisponivel: 'Conversaciones no está disponible',
  },
  erros: {
    '131047': '131047 · Ventana de 24 horas cerrada',
    '131026': '131026 · Número sin WhatsApp o que no acepta el mensaje',
    '131048': '131048 · Restricción por spam (calidad del número)',
    '131049': '131049 · Límite de marketing por usuario (Meta pide esperar 24 h)',
    '131056': '131056 · Demasiados mensajes al mismo número',
    '130429': '130429 · Capacidad del número',
    '132000': '132000 · Variables de la plantilla',
    '132001': '132001 · Plantilla inexistente o no aprobada',
    outro: '{{codigo}} · Error de Meta',
    semCodigo: 'Rechazado por MalgoOS (teléfono o variables)',
  },
  consentimentos: {
    abrir: 'Consentimientos',
    titulo: 'Consentimientos de WhatsApp',
    texto: 'Quién puede recibir mensajes: el registro de cada autorización y de cada salida, con el origen, la fecha y quién lo registró. Sin registro vale la regla estándar: quien escribió a la empresa recibe; el cliente con contrato activo recibe avisos.',
    colunas: { contato: 'Contacto', tipo: 'Tipo', situacao: 'Estado', origem: 'Origen', quem: 'Quién registró', quando: 'Cuándo' },
    situacoes: { autorizou: 'Autorizó', saiu: 'Salió' },
    origens: { contrato: 'Contrato activo', conversa: 'Escribió a la empresa', formulario: 'Formulario del sitio', importacao: 'Planilla declarada', manual: 'Registro manual', botao_parar: 'Botón "Dejar de recibir"', palavra: 'Lo pidió en la conversación' },
    registrar: 'Registrar',
    telefone: 'Teléfono',
    tipos: 'Vale para',
    tiposOpcoes: { ambos: 'Marketing y avisos', marketing: 'Solo marketing', avisos: 'Solo avisos' },
    situacao: 'Estado',
    observacao: 'Observación (cómo el contacto lo pidió o autorizó)',
    registrado: 'Consentimiento registrado',
    vazio: 'Ningún registro todavía.',
    sistema: 'Automático',
  },
};

export const broadcastI18n = { pt, en, es };
